<ng-container *ifScreenSize="screenType.Mobile">
  <ng-container *ngIf="isHomePage; else pageHeader">
    <ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
      <div class="mobile-page-header container py-3 bg-primary" [ngClass]="{ 'show-after': showAfter }">
        <div class="d-flex flex-column h-100 border-disabled gap-3">
          <div class="d-flex justify-content-between">
            <!--Name and ID-->
            <div class="card-id text-start">
              <h5 class="mb-1 mb-lg-1 font-size-18 fw-bold card-name text-white" *ngIf="memberDetails$ | async as memberDetails">
                {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
              </h5>
              <div class="d-flex mb-0 mb-lg-2 card-name-info text-white">
                <div>
                  {{ memberCard.MemberId }}
                </div>
                <div class="px-1">-</div>
                <div>{{ 'member.card.id' | translate }}</div>
              </div>
            </div>
            <button class="btn d-flex btn-redirect-wallet bg-glass" [routerLink]="'/rewards/wallet'">
              <div class="icon material-symbols-outlined">qr_code_scanner</div>
              <div class="text-white">{{ 'card.wallet.button' | translate }}</div>
            </button>
          </div>

          <!-- points and cash -->
          <ng-container *notInPopulation="[populations.U18]">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex mb-1 points-container w-100 justify-content-between">
                <div class="points-item bg-glass ms-auto">
                  <div class="d-flex align-items-center">
                    <span>{{ 'member.card.your.points' | translate }}</span>
                  </div>
                  <div class="d-flex ms-auto">
                    <span class="icons material-icons" aria-hidden="true">loyalty</span>
                    <div class="points-balance ms-2">
                      <div class="text-number font-size-18">
                        {{ pointsBalance$ | async | number: '1.0-0' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- navigation -->
          <ng-container>
            <div class="mobile-navigation d-flex flex-row align-items-center pb-2 mb-2">
              <div class="navigation" routerLink="/rewards">
                <span class="icons material-symbols-outlined bg-glass mb-1"> redeem </span>
                <a class="text-white font-size-14">{{ 'card.rewards.button' | translate }}</a>
              </div>

              <div class="navigation" routerLink="/challenges">
                <span class="icons material-symbols-outlined bg-glass mb-1"> emoji_events </span>
                <a class="text-white font-size-14">{{ 'card.challenges.button' | translate }}</a>
              </div>

              <div class="navigation" routerLink="/games">
                <span class="icons material-symbols-outlined bg-glass mb-1"> stadia_controller </span>
                <a class="text-white font-size-14">{{ 'card.games.button' | translate }}</a>
              </div>

              <ng-container *notInPopulation="[populations.U18]">
                <div class="navigation" routerLink="/earn">
                  <span class="icons material-symbols-outlined bg-glass mb-1"> money </span>
                  <a class="text-white font-size-14">{{ 'card.earn.button' | translate }}</a>
                </div>
              </ng-container>

              <ng-container *inPopulation="[populations.U18]">
                <div class="navigation" routerLink="gallery">
                  <span class="icons material-symbols-outlined bg-glass mb-1">animated_images</span>
                  <a class="text-white font-size-14">{{ 'card.gallery.button' | translate }}</a>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-template #loadingRef>
      <fgbcl-loading></fgbcl-loading>
    </ng-template>
  </ng-container>

  <ng-template #pageHeader>
    <div class="page-header bg-primary">
      <div class="d-flex align-items-center text-white">
        <div class="banner-name">
          <ng-container *notInPopulation="[populations.TicketTransfer]">
            <a (click)="goBack()" class="btn back-btn text-white px-0">
              <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
            </a>
            <h4 class="mb-0" [ngClass]="{ 'text-title-center': !showBalance }">
              {{ pageTitle | translate | uppercase }}
            </h4>
          </ng-container>
        </div>
        <div *ngIf="showBalance" class="ms-auto d-flex align-items-center widget-details">
          <div class="balance-details d-flex bg-glass-dark align-items-center">
            <span class="icons material-icons"> loyalty </span>
            <div class="balance">
              <p class="mb-0 font-size-14 fw-bold">{{ pointsBalance$ | async | number: '1.0-0' : 'en-GB' }}</p>
            </div>
          </div>

          <button *ngIf="showQr" class="qrcode-btn text-white bg-glass-dark" (click)="gotoWallet()">
            <span class="icon material-icons material-mobile-nav">qr_code</span>
          </button>
        </div>
      </div>
      <div class="footer"></div>
    </div>
  </ng-template>
</ng-container>
